import { helpers } from 'vuelidate/lib/validators'
import { imageDimensions } from './image'
import moment from 'moment'

export function isAfterDate (field, granularity, format) {
  return (date, vm) => {
    if (!helpers.req(date)) return true
    const thisDateObject = moment.utc(date, format)
    const otherDateObject = moment.utc(vm[field], format)
    return thisDateObject.isAfter((otherDateObject), granularity)
  }
}

export function isBeforeDate (field, granularity, format) {
  return (date, vm) => {
    if (!helpers.req(date)) return true
    const thisDateObject = moment.utc(date, format)
    const otherDateObject = moment.utc(vm[field], format)
    return thisDateObject.isBefore((otherDateObject), granularity)
  }
}

export function isSameDate (field, granularity, format) {
  return (date, vm) => {
    if (!helpers.req(date)) return true
    const thisDateObject = moment.utc(date, format)
    const otherDateObject = moment.utc(vm[field], format)
    return thisDateObject.isSame((otherDateObject), granularity)
  }
}

export function notAllowedChars (notAllowedChars) {
  const regex = new RegExp(`[${notAllowedChars}]`)
  return (value) => !regex.test(value)
}

export function step (step) {
  return (value) => step ? !value || (typeof value === 'number' && ((value * 100).toFixed(4) % (step * 100).toFixed(4) === 0)) : true
}

export function oneOf (acceptableValues = []) {
  return (value) => {
    if (!helpers.req(value)) return true
    return acceptableValues.includes(value)
  }
}

export async function imageIsSquare (file) {
  const { width, height } = await imageDimensions(file)
  return width === height
}

export function notIn (unacceptableValues) {
  return (value) => !unacceptableValues.includes(value)
}

export function sumOfPercentOwnership (expectedValue) {
  return (value) => {
    // When no value is set, we are showing equally distributed percentage with a sum of 100%
    if (!value || !Array.isArray(value) || value.length === 0) return true

    return value.filter(dept => dept.percentOwnership).reduce((partialSum, dept) => partialSum + parseFloat(dept.percentOwnership), 0) === expectedValue
  }
}

export default {
  isAfterDate,
  isBeforeDate,
  isSameDate,
  notAllowedChars,
  step,
  oneOf,
  notIn,
  sumOfPercentOwnership,
}
